export const Menudata = {
  documents: [
    {
      Id: 1,
      Name: '실시간 통계',
      path: '/User/DashBoard/MainStats',
    },
    {
      Id: 2,
      Name: '현장 모니터링',
      path: '/User/DashBoard/SceneStats',
    },
    {
      Id: 3,
      Name: '안전사고 통계 정보 조회',
      path: '/User/DashBoard/LookUpStats',
    },
    {
      Id: 7,
      Name: '관리',
      Sheets: [
        {
          Id: 4,
          Name: '환경 관리',
          Sheets: [
            {
              Id: 1,
              Name: '현장 정보 관리',
              path: '/User/EnvManage/SceneInfo',
            },

            {
              Id: 2,
              Name: '현장 장비 배치 관리',
              path: '/User/EnvManage/SceneLocation',
            },
          ],
        },
        {
          Id: 5,
          Name: 'IoT 관리',
          Sheets: [
            {
              Id: 1,
              Name: '장비관리',
              path: '/User/IoTManage/DeviceManage',
            },
            {
              Id: 2,
              Name: '그룹관리',
              path: '/User/IoTManage/GroupManage',
            },
            {
              Id: 3,
              Name: 'OTA',
              path: '/User/IoTManage/OTA',
            },
          ],
        },
        {
          Id: 6,
          Name: '시스템 관리',
          Sheets: [
            {
              Id: 1,
              Name: '조직 관리',
              path: '/User/SysManage/ManageOrg',
            },
            {
              Id: 2,
              Name: '계정 관리',
              path: '/',
            },
            {
              Id: 3,
              Name: '로그 관리',
              path: '/',
            },
          ],
        },
      ],
    },
  ],
}

export const MUI_X_PRODUCTS = [
  {
    id: '1',
    label: '실시간 통계',
    path: '/User/DashBoard/MainStats',
  },
  {
    id: '2',
    label: '현장 모니터링',
    path: '/User/DashBoard/SceneStats',
  },
  {
    id: '3',
    label: '안전사고 통계 정보 조회',
    path: '/User/DashBoard/LookUpStats',
  },
  {
    id: '5',
    label: '근로자 작업',
    children: [
      {
        id: '5_1',
        label: '작업투입',
        path: '/Worker/WorkerIN',
      },
      {
        id: '5_2',
        label: '작업철수',
        path: '/Worker/WorkerOUT',
      },
    ],
  },

  {
    id: '4',
    label: '관리',
    children: [
      {
        id: '4_1',
        label: '환경 관리',
        children: [
          {
            id: '4_1_1',
            label: '현장 정보 관리',
            path: '/User/EnvManage/SceneInfo',
          },

          {
            id: '4_1_2',
            label: '현장 장비 배치 관리',
            path: '/User/EnvManage/SceneLocation',
          },
        ],
      },
      {
        id: '4_2',
        label: 'IoT 관리',
        children: [
          {
            id: '4_2_1',
            label: '장비관리',
            path: '/User/IoTManage/DeviceManage',
          },
          {
            id: '4_2_2',
            label: '그룹관리',
            path: '/User/IoTManage/GroupManage',
          },
          {
            id: '4_2_3',
            label: 'OTA',
            path: '/User/IoTManage/OTA',
          },
        ],
      },
      {
        id: '4_3',
        label: '시스템 관리',
        children: [
          {
            id: '4_3_1',
            label: '조직 관리',
            path: '/User/SysManage/ManageOrg',
          },
          {
            id: '4_3_2',
            label: '계정 관리',
            path: '/User/SysManage/AccountManage',
          },
          {
            id: '4_3_3',
            label: '로그 관리',
            path: '/User/SysManage/LogManage',
          },
        ],
      },
    ],
  },
]
// export const MUI_X_PRODUCTS1 = [
//   {
//     id: '1',
//     label: '작업투입',
//     path: '/Worker/WorkerIN',
//   },
//   {
//     id: '2',
//     label: '작업철수',
//     path: '/Worker/WorkerOUT',
//   }

// ]
